import React from "react";
import Card from "../Card";
import { MdArrowDropUp } from "react-icons/md";
import {
  barChartOptionsDailyTraffic,
  barChartDataDailyTraffic,
} from "../../variables/charts";

import BarChart from "../Charts/BarChart";

export default function DailyTraffic({ Barchart }) {
  barChartDataDailyTraffic[0]["data"] = Barchart['listdata'];
  barChartOptionsDailyTraffic.xaxis.categories = Barchart['categories'];
  var sum = Barchart['listdata']?.reduce((accumulator, currentValue) => {
    return accumulator + currentValue
  },0);
  return (
    <Card extra="pb-7 p-[20px]">
      <div className="flex flex-row justify-between">
        <div className="ml-1 pt-2">
          <p className="text-sm font-medium leading-4 text-gray-600">
            Weekly Traffic
          </p>
          <p className="text-[34px] font-bold text-navy-700 dark:text-white">
            {sum}{" "}
            <span className="text-sm font-medium leading-6 text-gray-600">
              Visitors
            </span>
          </p>
        </div>
        <div className="mt-2 flex items-start">
          <div className="flex items-center text-sm text-green-500">
            <MdArrowDropUp className="h-5 w-5" />
            <p className="font-bold"> +2.45% </p>
          </div>
        </div>
      </div>

      <div className="h-[300px] w-full pt-10 pb-0">
        <BarChart
          chartData={barChartDataDailyTraffic}
          chartOptions={barChartOptionsDailyTraffic}
        />
      </div>
    </Card>
  );
}
